// extracted by mini-css-extract-plugin
module.exports = {"rotate":"RotateDevice_rotate__L1Ar1","wrapper":"RotateDevice_wrapper__pcaYw"};